/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrderStakeholderItemsReportDetailsQuery } from '../../models/get-order-stakeholder-items-report-details-query';
import { GetOrderStakeholderItemsReportDetailsQueryResult } from '../../models/get-order-stakeholder-items-report-details-query-result';

export interface ApiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Params {
      body?: GetOrderStakeholderItemsReportDetailsQuery
}

export function apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderStakeholderItemsReportDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrderStakeholderItemsReportDetailsQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetOrderStakeholderItemsReportDetailsPost.PATH = '/api/NurseryManager/Reports/GetOrderStakeholderItemsReportDetails';
